"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactUs = contactUs;
const axios_1 = require("./clients/axios");
async function contactUs(args) {
    return (await axios_1.client.post('/0/contact-us', args)).data;
}
